/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CsvColumnSourceDto,
  CsvConfigurationCreateRequest,
  CsvConfigurationDto,
  CsvConfigurationUpdateRequest,
  CsvExportRequest,
  CsvOptionsResponse,
  DownloadAccountingAttributeRequest,
  SearchSourcesRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiCsvExportController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name UpdateCsvConfiguration
   * @request PUT:/api/v1/csv-export/configurations/{id}
   */
  updateCsvConfiguration = (
    id: string,
    data: CsvConfigurationUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CsvConfigurationDto, any>({
      path: `/v1/csv-export/configurations/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateCsvConfigurationPath = '/v1/csv-export/configurations/${id}'
  static updateCsvConfigurationMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name DeleteCsvConfiguration
   * @request DELETE:/api/v1/csv-export/configurations/{id}
   */
  deleteCsvConfiguration = (id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/csv-export/configurations/${id}`,
      method: 'DELETE',
      ...params,
    })

  static deleteCsvConfigurationPath = '/v1/csv-export/configurations/${id}'
  static deleteCsvConfigurationMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name ExportCsv
   * @request POST:/api/v1/csv-export/export
   */
  exportCsv = (data: CsvExportRequest, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/csv-export/export`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static exportCsvPath = '/v1/csv-export/export'
  static exportCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name SearchCsvConfigurations
   * @request GET:/api/v1/csv-export/configurations
   */
  searchCsvConfigurations = (params: RequestParams = {}) =>
    this.http.request<CsvConfigurationDto[], any>({
      path: `/v1/csv-export/configurations`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static searchCsvConfigurationsPath = '/v1/csv-export/configurations'
  static searchCsvConfigurationsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name CreateCsvConfiguration
   * @request POST:/api/v1/csv-export/configurations
   */
  createCsvConfiguration = (data: CsvConfigurationCreateRequest, params: RequestParams = {}) =>
    this.http.request<CsvConfigurationDto, any>({
      path: `/v1/csv-export/configurations`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createCsvConfigurationPath = '/v1/csv-export/configurations'
  static createCsvConfigurationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name SearchCsvConfigurationSources
   * @request POST:/api/v1/csv-export/configurations/{configurationId}/sources
   */
  searchCsvConfigurationSources = (
    configurationId: string,
    data: SearchSourcesRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CsvColumnSourceDto[], any>({
      path: `/v1/csv-export/configurations/${configurationId}/sources`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static searchCsvConfigurationSourcesPath =
    '/v1/csv-export/configurations/${configurationId}/sources'
  static searchCsvConfigurationSourcesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name DownloadAccountingAttribute
   * @request POST:/api/v1/csv-export/accounting-attributes/csv-download
   */
  downloadAccountingAttribute = (
    data: DownloadAccountingAttributeRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/csv-export/accounting-attributes/csv-download`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static downloadAccountingAttributePath = '/v1/csv-export/accounting-attributes/csv-download'
  static downloadAccountingAttributeMethod = 'POST'
  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name SearchCsvTemplates
   * @request GET:/api/v1/csv-export/templates
   */
  searchCsvTemplates = (params: RequestParams = {}) =>
    this.http.request<CsvConfigurationDto[], any>({
      path: `/v1/csv-export/templates`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static searchCsvTemplatesPath = '/v1/csv-export/templates'
  static searchCsvTemplatesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name FindCsvTemplateById
   * @request GET:/api/v1/csv-export/templates/{templateId}
   */
  findCsvTemplateById = (templateId: string, params: RequestParams = {}) =>
    this.http.request<CsvConfigurationDto, any>({
      path: `/v1/csv-export/templates/${templateId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findCsvTemplateByIdPath = '/v1/csv-export/templates/${templateId}'
  static findCsvTemplateByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name SearchCsvConfigurationOptions
   * @request GET:/api/v1/csv-export/options
   */
  searchCsvConfigurationOptions = (params: RequestParams = {}) =>
    this.http.request<CsvOptionsResponse, any>({
      path: `/v1/csv-export/options`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static searchCsvConfigurationOptionsPath = '/v1/csv-export/options'
  static searchCsvConfigurationOptionsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-csv-export-controller
   * @name FindCsvConfigurationById
   * @request GET:/api/v1/csv-export/configurations/{configurationId}
   */
  findCsvConfigurationById = (configurationId: string, params: RequestParams = {}) =>
    this.http.request<CsvConfigurationDto, any>({
      path: `/v1/csv-export/configurations/${configurationId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findCsvConfigurationByIdPath = '/v1/csv-export/configurations/${configurationId}'
  static findCsvConfigurationByIdMethod = 'GET'
}
